export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET;
export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID;
export const viewerToken = process.env.SANITY_VIEWER_TOKEN;
export const studioUrl = process.env.NEXT_PUBLIC_SANITY_STUDIO_URL;

// Values you may additionally want to configure globally
export const apiVersion = process.env.NEXT_PUBLIC_SANITY_API_VERSION || '2024-07-11';
